import type { Category } from './types';

// Colors mirror `Market Map Template - Categories.csv` so dev/demo mode
// matches production. IDs stay on the legacy demo names (`bakery`, `meatdairy`,
// ...) because the demo vendor fixtures in `data/demo.ts`
// reference them; `LEGACY_ALIASES` in `CategoryGlyph.tsx` + `markerSvg.ts`
// maps them onto the canonical glyphs. Storefront gets a new brownstone
// brown (the CSV leaves that column blank).
export const DEFAULT_CATEGORIES: Category[] = [
  { id: 'produce',   name: 'Produce',        color: '#4e9050' },
  { id: 'bakery',    name: 'Bakery',         color: '#a88a40' },
  { id: 'meatdairy', name: 'Meat & Dairy',   color: '#4472a8' },
  { id: 'flowers',   name: 'Flowers',        color: '#4e9050' },
  { id: 'prepared',  name: 'Prepared Food',  color: '#b04838' },
  { id: 'beverages', name: 'Beverages',      color: '#b07348' },
  { id: 'seafood',   name: 'Seafood',        color: '#4472a8' },
  { id: 'specialty', name: 'Specialty',      color: '#7050a0' },
  { id: 'crafts',    name: 'Crafts',         color: '#7050a0' },
  { id: 'makers',    name: 'Makers',         color: '#7050a0' },
  { id: 'info',      name: 'Info',           color: '#387890' },
  { id: 'store',     name: 'Store',          color: '#6b4e35' },
];
